import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-900 dark:bg-gray-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">T</span>
              </div>
              <span className="text-xl font-semibold">tiering.de</span>
            </div>
            <p className="text-gray-300 text-sm mb-4 max-w-md">
              {t('footer.description')}
            </p>
            <p className="text-gray-400 text-xs">
              {t('footer.contact')}: info@tiering.de
            </p>
          </div>

          {/* Navigation links */}
          <div>
            <h3 className="text-sm font-semibold mb-4">{t('footer.navigation')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white text-sm">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-gray-300 hover:text-white text-sm">
                  {t('nav.search')}
                </Link>
              </li>
              <li>
                <Link to="/suggestions" className="text-gray-300 hover:text-white text-sm">
                  {t('nav.suggestions')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal links */}
          <div>
            <h3 className="text-sm font-semibold mb-4">{t('footer.legal')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-white text-sm">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-white text-sm">
                  {t('footer.terms')}
                </Link>
              </li>
              <li>
                <Link to="/imprint" className="text-gray-300 hover:text-white text-sm">
                  {t('footer.imprint')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom section */}
        <div className="border-t border-gray-800 mt-8 pt-6 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-xs">
            © {currentYear} tiering.de. {t('footer.rights')}
          </p>
          <div className="mt-4 sm:mt-0">
            <Link 
              to="/suggestions" 
              className="text-blue-400 hover:text-blue-300 text-xs"
            >
              {t('footer.suggestions')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer